import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tree-structure-icon',
  templateUrl: './tree-structure-icon.component.html',
  styleUrls: ['./tree-structure-icon.component.scss']
})
export class TreeStructureIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
